module.exports = __webpack_public_path__ + "img/sockets-icon.5b86b9bc.svg";